import { errorMessage } from "@/api";
import { Button } from "@/ui";

interface ErrorBannerProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

/** Inline error with the API's message and a Retry button; render above stale data. */
export function ErrorBanner({ error, onRetry, title = "Could not load" }: ErrorBannerProps) {
  if (!error) return null;
  return (
    <div className="banner" role="alert">
      <span>
        <strong>{title}:</strong> {errorMessage(error)}
      </span>
      {onRetry ? (
        <Button size="sm" variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
